/**
 * Form button widget appearance
 * Defined in WidgetAppearance.kt
 */
export const PRIMARY = 'primary'
export const SECONDARY = 'secondary'
